import { Component, Input, OnInit } from '@angular/core';
import { SubBoardListItemModel } from '../../models/sub-board-list-item-model';

@Component({
    selector: 'app-substitution-request-list-item',
    templateUrl: './substitution-request-list-item.component.html',
    styleUrls: ['./substitution-request-list-item.component.scss'],
    standalone: false
})
export class SubstitutionRequestListItemComponent implements OnInit {
    @Input() public model: SubBoardListItemModel;

    @Input() public showStatus = true;

    constructor() {}

    ngOnInit() {}
}
